(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-row-match-analyses/assets/javascripts/coupon-row-match-analysis.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-row-match-analyses/assets/javascripts/coupon-row-match-analysis.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$components$sport = svs.components.sportinfo.gameAnalysesRedux.selectors,
  selectMatchAnalysis = _svs$components$sport.selectMatchAnalysis,
  selectAuthorProfile = _svs$components$sport.selectAuthorProfile;
const CouponRowMatchAnalysis = _ref => {
  let analysisId = _ref.analysisId,
    isGoalCount = _ref.isGoalCount;
  const matchAnalysis = useSelector(state => selectMatchAnalysis(state, analysisId));
  const authorProfile = useSelector(state => selectAuthorProfile(state, matchAnalysis === null || matchAnalysis === void 0 ? void 0 : matchAnalysis.authorId));
  return React.createElement("div", {
    className: "coupon-row-match-analysis"
  }, !isGoalCount && React.createElement("h3", {
    className: "coupon-row-match-analysis-header"
  }, "Analys av ".concat(authorProfile.authorLongName, ":")), React.createElement("p", {
    className: "coupon-row-match-analysis-body"
    ,
    dangerouslySetInnerHTML: {
      __html: matchAnalysis.body
    }
  }));
};
setGlobal('svs.components.tipsen.couponRowMatchAnalyses.CouponRowMatchAnalysis', CouponRowMatchAnalysis);

 })(window);